module.exports = __webpack_public_path__ + "assets/img/61c0-ai.svg";